var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component/lib';
import RootType from "../store/mutation-types";
import LoginService from "../../src/api/LoginService";
import CommonService from "../../src/api/CommonService";
import { CachePocily } from "../common/Cache";
import { ECache } from '../enum/ECache';
import CACHE_KEY from '../constant/cacheKey';
import Password from "./account/Dialog.vue";
import Register from "./Register.vue";
import PasswordSetting from "../components/login/PasswordSetting.vue";
import RegexStr from "../common/RegexStr";
import { UrlHelper } from "../helper/UrlWrapper";
import { ESendCodeType } from "../enum/ESendCodeType";
import AuthMixin from "../common/components/AuthMixin";
var phoneRegex = new RegExp(RegexStr.mobile);
var checkNoRegex = /\d{6}/;
var checkMsg = "发送验证码";
var EShowType;
(function (EShowType) {
    EShowType[EShowType["No"] = 1] = "No";
    EShowType[EShowType["Pwd"] = 2] = "Pwd";
})(EShowType || (EShowType = {}));
var Login = (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.showType = EShowType.No;
        _this.checkMsg = checkMsg;
        _this.loginForm = {
            supplier_phone: "",
            phone: "",
            password: "",
            checkNo: "",
            isRem: true,
            token: "",
            info_complete: 0,
            nickname: '',
            supplier_id: "",
        };
        _this.bannerImgs = [{
                src: "../../static/image/banner_two.png"
            }, {
                src: "../../static/image/banner_one.png"
            }];
        return _this;
    }
    Login.prototype.created = function () {
        this.service = LoginService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    Login.prototype.checkLogin = function () {
        var msg = "";
        if (!phoneRegex.test(this.loginForm.phone)) {
            msg = "手机号格式不正确";
        }
        else if (this.showType === EShowType.Pwd && !this.loginForm.password) {
            msg = "密码不能为空";
        }
        else if (this.showType === EShowType.No && !checkNoRegex.test(this.loginForm.checkNo)) {
            msg = "验证码必须位6位数字";
        }
        return {
            success: !msg,
            msg: msg
        };
    };
    Login.prototype.setPassword = function () {
        var instance = this.$dialog(Password, {
            data: {
                isChangePwd: false
            }
        }, {
            title: "忘记密码",
            width: 600,
            height: 350
        }).instance;
    };
    Login.prototype.register = function (registercode) {
        var instance = this.$dialog(Register, {
            data: {
                registercode: (registercode instanceof Event) ? '' : registercode || ""
            }
        }, {
            title: "账号注册",
            width: 600,
            height: 580,
        }).instance;
    };
    Login.prototype.filterPhone = function () {
        this.loginForm.phone = this.loginForm.phone.replace(/[^\d-]/g, '');
        if (this.loginForm.phone.length > 11) {
            this.loginForm.phone = this.loginForm.phone.substring(0, 11);
        }
    };
    Login.prototype.filterSupplierPhone = function () {
        this.loginForm.supplier_phone = this.loginForm.supplier_phone.replace(/[^\d-]/g, '');
        if (this.loginForm.supplier_phone.length > 11) {
            this.loginForm.supplier_phone = this.loginForm.supplier_phone.substring(0, 11);
        }
    };
    Login.prototype.filterCode = function () {
        this.loginForm.checkNo = this.loginForm.checkNo.replace(/[^0-9]/g, '');
        if (this.loginForm.checkNo.length > 6) {
            this.loginForm.checkNo = this.loginForm.checkNo.substring(0, 6);
        }
    };
    Login.prototype.virtualLogin = function () {
        var _this = this;
        var result = this.checkLogin();
        if (!result.success) {
            this.$message.error(result.msg);
            return;
        }
        this.clearFlag();
        this.service.virtualLogin({ phone: this.loginForm.phone, supplier_phone: this.loginForm.supplier_phone, smscode: this.loginForm.checkNo }).then(function (res) {
            res = res.data;
            _this.loginForm.token = res.data.token;
            _this.loginForm.nickname = res.data.nickname;
            _this.loginForm.supplier_id = res.data.supplier_id;
            _this.loginForm.info_complete = res.data.info_complete;
            _this.cache.save(CACHE_KEY.LOGIN, {
                ctime: new Date().getTime(),
                userInfo: JSON.stringify(_this.loginForm)
            });
            _this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, _this.loginForm));
            _this['getConfig'](_this.loginForm.supplier_id);
            _this['getOpenedCode']();
            _this['getOpenedEdiStatus']();
            if (res.data.is_first) {
                var instance = _this.$dialog(PasswordSetting, {
                    data: {
                        isChangePwd: true
                    }
                }, {
                    title: "设置密码",
                    width: 300,
                    height: 330,
                    closeBtn: false
                }).instance;
                instance.$on("setPassword:ok", function () {
                    _this.$message.success('设置成功！');
                    _this.$router.replace({
                        name: "Home"
                    });
                });
            }
            else {
                _this.$router.push('/home');
            }
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Login.prototype.getCheckNo = function () {
        var _this = this;
        if (this.timeFlag) {
            return;
        }
        var num = 60;
        this.checkMsg = num + "s \u540E\u91CD\u8BD5";
        this.timeFlag = setInterval(function () {
            num--;
            if (num === 0) {
                _this.clearFlag();
            }
            else {
                _this.checkMsg = num + "s \u540E\u91CD\u8BD5";
            }
        }, 1000);
        this.commonService.sendCode({ phone: this.loginForm.phone, type: ESendCodeType.virtual }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Login.prototype.clearFlag = function () {
        clearInterval(this.timeFlag);
        this.timeFlag = 0;
        this.checkMsg = checkMsg;
    };
    Login.prototype.mounted = function () {
        var infor = this.cache.getData(CACHE_KEY.LOGIN);
        if (infor) {
            if (infor.userInfo) {
                this.loginForm = JSON.parse(infor.userInfo);
                this.$store.commit(RootType.UPDATE_LOGINMODEL, Object.assign({}, this.loginForm));
                this.$router.push('/home');
                this['getConfig'](this.loginForm.supplier_id);
                this['getOpenedCode']();
                this['getOpenedEdiStatus']();
            }
        }
        var registercode = UrlHelper.getQueryString(location.href, "registercode");
        if (registercode) {
            this.register(registercode);
        }
    };
    Login = __decorate([
        Component({
            mixins: [AuthMixin],
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
